import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useMemo } from 'react'

import { uniqueId } from 'utils/strings'

import Tooltip from 'components/Shared/Tooltip/Index'

import colors from 'components/utils/colors'

const StyledWrapper = styled.div`
  && {
    display: flex;
    margin: 0 8px 0 0;
    border-radius: 8px;
    background: ${props => props.bgColor};
    height: 16px;
    box-sizing: border-box;
  }
`

const MultiValueContainer = (props) => {
  const tooltipId = useMemo(() => uniqueId(), [])
  const bgColor = props.data.bgColor || colors.secondary90

  if (props.data.shortLabel) {
    return (
      <>
        <Tooltip id={tooltipId} />
        <StyledWrapper
          {...props.innerProps}
          bgColor={bgColor}
          data-tooltip-content={props.data.label}
          data-tooltip-id={tooltipId}
        >
          {props.children}
        </StyledWrapper>
      </>
    )
  }

  return (
    <StyledWrapper {...props.innerProps} bgColor={bgColor}>
      {props.children}
    </StyledWrapper>
  )
}

MultiValueContainer.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  innerProps: PropTypes.object,
  children: PropTypes.node,
}

export default MultiValueContainer
